import React from 'react'
import './Loading.css'

export const Loading = () => (
  <div className="loading-container">
    <div className="loader">
      <span />
      <span />
      <span />
      <span />
    </div>
    <p className="loading-text">Loading, please wait...</p>
  </div>
)
